import { getEntity, getEntityById, updateEntity, createEntity, deleteEntity } from '@/api/entity'
import Vue from 'vue'

const state = {
    entityList: [],
    totalCounts: 0
}

const getters = {
}

const actions = {
  async getEntityAction({ commit }, payload) {
    try {
      const res = await getEntity(payload)
      commit('SET_ENTITY', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
  async createEntityAction({ commit }, payload) {
    try {
      const newEntity = await createEntity(payload);
      commit('ADD_ENTITY', newEntity.data)
    } catch (error) {
      throw error.message
    }
  },
  async updateEntityAction({ commit }, payload) {
      try {
          const newEntity = await updateEntity(payload.id, payload.data)
          commit("UPDATE_ENTITY", newEntity.data)
          return newEntity.data
      } catch (error) {
          throw error.message
      }
  },
  async deleteEntityAction({ commit }, payload) {
    try {
      await deleteEntity(payload)
      commit('DELETE_ENTITY', payload)
    } catch (error) {
      throw error.message
    }
  }
}

const mutations = {
  SET_ENTITY(state, payload) {
    state.entityList = payload.entityList
    state.totalCounts = payload.totalCounts
  },
  UPDATE_ENTITY(state, entity) {
    Vue.set(state.entityList, state.entityList.findIndex(x => x._id === entity._id), entity)
  },
  ADD_ENTITY(state, sales) {
    state.entityList.unshift(sales)
    state.totalCounts++
  },
    // UPDATESALES(state, sales) {
    //     Vue.set(state.sales, state.sales.findIndex(x => x._id === sales._id), sales)
    // },
  DELETE_ENTITY(state, id) {
    state.entityList = state.entityList.filter(e => e._id !== id)
    state.totalCounts--
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}